import { render, staticRenderFns } from "./Exercise.vue?vue&type=template&id=4903f24c"
import script from "./Exercise.vue?vue&type=script&lang=js"
export * from "./Exercise.vue?vue&type=script&lang=js"
import style0 from "./Exercise.vue?vue&type=style&index=0&id=4903f24c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports